import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";
import {currencySymbol} from "../../../../../../gd/format/currency-symbol";

// const debug = "FieldItemModelCalculatedServiceCost_TableCell"
const debug = false

export default function FieldItemModelCalculatedServiceCost_TableCell (props: FieldTableCellProps) {


    const classes = Classes("cell-flex ui5-txt-less-important-small")

    let content = null
    let showSummary = false

    if (props.listItem.isCollapsed && props.listItem.childrenItems.length > 0 && (props.listItem.costInternal.total>props.listItem.costInternal.own)) {
        content         = props.listItem.costExternal.total
        showSummary     = true
    } else{
        content         = props.listItem.costExternal.own
    }

    const hasValue : boolean = !!content && content >0
    const displayValue = props.field.getDisplayValue(content)

    return (
        <React.Fragment>
            <div className={classes} style={getTableCellStyle(props)}>
                {showSummary && <div className="ui5-ico-12 i5-summary-symbol m-r-5"/>}

                {hasValue &&
                    <>
                        <span className="ui5-txt-not-important-small m-r-3">{currencySymbol()}</span>
                        {displayValue}
                    </>
                }
            </div>
        </React.Fragment>
    )

}



